import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Layout from "./containers/layout/layout";
import "./App.css";

function App() {
  return <Layout />;
}

export default App;
